import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../utils/helper';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../common/block-text/block-text.component';
import {
  WhatsappInitModel,
  WhatsappInitVariables,
  WhatsappModel,
  WhatsappVariables,
} from '../../../../models/whatsapp-template/whatsapp.interface';
import { NotificationComponent } from '../../common/notification/notification.component';
import { PinComponent } from '../../common/pin/pin.component';
import { BaseComponent } from '../../common/BaseComponent';
import { VariableMaxLengthService } from '../../../../services/variable-max-length.service';

@Component({
    selector: 'app-whatsapp',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './whatsapp.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './whatsapp.component.scss'
})
export class WhatsappComponent extends BaseComponent implements OnInit {
  @Input() block: WhatsappModel = new WhatsappInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  currentTime: string = new Date().toISOString().slice(11, 16);

  count: number = 0;

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new WhatsappInitVariables()
    }
  }

  //placeholders:
  whatsappImagePlaceholder = 'Choose or dropdown an image';
  whatsappTextPlaceholder = 'Enter copy text';
  whatsappCtaTextPlaceholder = 'Enter CTA text';
  whatsappCtaLinkPlaceholder = 'Enter CTA link';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof WhatsappVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
